// Root mutations
export default {
  SET_LATEST(state, value) {
    state.latest = value
  },
  SET_ETA(state, value) {
    state.eta = value
  },
  SET_DIRECTIONS(state, payload) {
    state.directions = payload
  },
  SET_DESTINATION(state, payload) {
    state.destination = payload
  },
  SET_DISTANCE_TO_SITE(state, payload) {
    state.distanceToSite = payload
  }
}
